module.exports = __webpack_public_path__ + "img/about.c6beb716.jpg";